var jweixin = require('jweixin-module');

export default {  
    //判断是否在微信中    
    isWechat: function() {  
        var ua = window.navigator.userAgent.toLowerCase();  
        if (ua.match(/micromessenger/i) == 'micromessenger') {  
            //console.log('是微信客户端')  
            return true;  
        } else {  
            //console.log('不是微信客户端')  
            return false;  
        }  
    },  
    initJssdk:function(callback){  
            var res = {};
			//注入config权限配置
			jweixin.config({  
			    debug: res.Model.debug,  
			    appId: res.Model.appId,  
			    timestamp: res.Model.timestamp,  
			    nonceStr: res.Model.nonceStr,  
			    signature: res.Model.signature,  
			    jsApiList: [//这里是需要用到的接口名称  
			        'checkJsApi',//判断当前客户端版本是否支持指定JS接口 
			        'chooseWXPay',//微信支付  
			    ]  
			});  
			if (callback) {  
			    callback(res.data);  
			} 
    },  
    //在需要定位页面调用  
    getlocation: function(callback) {  
        if (!this.isWechat()) {  
            //console.log('不是微信客户端')  
            return;  
        }  
        this.initJssdk(function(res) {  
            jweixin.ready(function() {  
                jweixin.getLocation({  
                    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'  
                    success: function (res) {  
                        // console.log(res);  
                        callback(res)  
                    },  
                    fail:function(res){  
                        console.log(res)  
                    },  
                    // complete:function(res){  
                    //     console.log(res)  
                    // }  
                });  
            });  
        });  
    },  
	closeWindow:function(){
			jweixin.closeWindow();
	},
    openlocation:function(data,callback){//打开位置  
        if (!this.isWechat()) {  
            //console.log('不是微信客户端')  
            return;  
        }  
        this.initJssdk(function(res) {  
            jweixin.ready(function() {  
                jweixin.openLocation({//根据传入的坐标打开地图  
                    latitude:data.latitude,  
                    longitude:data.longitude  
                });  
            });  
        });  
    },  
    chooseImage:function(param,callback){//选择图片  
        if (!this.isWechat()) {  
            //console.log('不是微信客户端')  
            return;  
        }  
        //console.log(data);  
        this.initJssdk(function(res) {  
            jweixin.ready(function() {  
                jweixin.chooseImage({  
                    count:param.count,  
                    sizeType:param.sizeType ? param.sizeType : ['compressed','original'],  
                    sourceType:param.sizeType ? param.sourceType : ['album','camera'],  
                    success:function(rs){  
                        callback(rs)  
                    }  
                })  
            });  
        });  
    },  
	uploadImage:function(param,callback){
		jweixin.uploadImage({
		  localId: param.localId, // 需要上传的图片的本地ID，由chooseImage接口获得
		  isShowProgressTips: 1, // 默认为1，显示进度提示
		  success: function (res) {
			var serverId = res.serverId; // 返回图片的服务器端ID
			param.serverId = serverId;
			callback(param);
		  },fail: function (res) {
			param.serverId = '';
			callback(param);
		  }
		})
	},
    //微信支付  
    wxpay: function(data,callback) {  
        if (!this.isWechat()) {  
            //console.log('不是微信客户端')  
            return;  
        }
        
        jweixin.config({  
            debug: data.JsSdk.debug,  
            appId: data.JsSdk.appId,  
            timestamp: data.JsSdk.timestamp,  
            nonceStr: data.JsSdk.nonceStr,  
            signature: data.JsSdk.signature,  
            jsApiList: [//这里是需要用到的接口名称  
                'checkJsApi',//判断当前客户端版本是否支持指定JS接口 
                'chooseWXPay',//微信支付  
            ]  
        }); 

        jweixin.ready(function() {  
            jweixin.chooseWXPay({  
                timestamp: data.JsPay.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符  
                nonceStr: data.JsPay.nonceStr, // 支付签名随机串，不长于 32 位  
                package: data.JsPay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）  
                signType: data.JsPay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'  
                paySign: data.JsPay.paySign, // 支付签名  
                success: function (res) { 
                    //alert(JSON.stringify(res));
                    callback({code: 200});
                },  
                fail:function(res){  
                    //res.Status = 500;
                    //callback(res)
                    callback({code: 500});
                },  
                complete:function(res){
                    if(res.errMsg == "chooseWXPay:cancel"){
                        callback({code: 500});
                    } 
                }  
            });  
        }); 
    }  
}  


// WEBPACK FOOTER //
// ./src/api/jwx.js